import React from "react";
import PropTypes from 'prop-types';
import { List } from '@cdm/quickenloans-library/lib';
import { testAttributes, listType } from "./Constants";
import { howToContainer, listCustomStyle } from './HowTo.module.scss';

const HowTo = ({ children = '', listChildren = '' }) => (
    <div className={howToContainer} data-testid={testAttributes.HOW_TO_CONTAINER}>
        {children}
        {listChildren && <List
            as={listType}
            testId={testAttributes.HOW_TO_LIST_CONTAINER}
            className={listCustomStyle}>
            {listChildren}
        </List>}
    </div>
);

HowTo.propTypes = {
    /** Main content, title & description */
    children: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.array
    ]),
    /** List content, will populate <List /> component */
    listChildren: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.array
    ]),
};

export default HowTo;
